<template>
    <div>
        <p>{{document.originalFilename}}</p>
        <img
        v-if="document.mimeType.includes('image')"
        :src="imgUrl + document.internalFilename"
        class="img-thumbnail"
        />
        <p v-else class="document-claim-view-new-window">
        <img v-if="showIcon" :src="require('../assets/theme/' + resellerId + '/images/new-window.svg')" alt="New window" title="New window" class="icon icon-claim-view-new-window"></img> 
        <a
            :href="imgUrl + document.internalFilename"
            target="_blank"
        >{{aText}}</a>
        </p>
    </div>
</template>
<script>
    export default {
        props: {
            document: {
                type: Object,
                required: true
            },
            resellerId: {
                type: Number,
                required: false,
                default: 0
            },
            aText : {
                type: String,
                required: false,
                default: 'Click here to download / view file'
            },
            imgUrl: {
                type: String,
                required: false,
                default: () => { return process.env.VUE_APP_API_BASE_URL + "/api/v1/document/download/" }
            }
        },
        computed: {
            showIcon() {
                return this.resellerId = 77
            }
        }
    }
</script>